export default __webpack_public_path__ + "static/media/plus_white.a62de545.svg";